module.exports = __webpack_public_path__ + "d882ad747d34e72b5db942259b11a6cc.svg";